import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { brandAssets } from "@/data/brand";

export default function AdminLogin() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("mt_admin_token", res.data.token);
      localStorage.setItem("mt_admin_email", res.data.email);
      toast.success("Signed in");
      navigate("/admin");
    } catch {
      toast.error(t("admin.login.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={brandAssets.logoWordmark} alt="MAD TURBO" className="h-10 mx-auto mb-6" />
          <h1 className="h-display text-4xl text-white">{t("admin.login.title")}</h1>
        </div>
        <form onSubmit={submit} className="card-mt p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="label-mt">{t("admin.login.email")}</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-mt" data-testid="admin-email" />
          </div>
          <div>
            <label className="label-mt">{t("admin.login.password")}</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-mt" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? "…" : t("admin.login.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
